<template>
    <div>
        <title-component></title-component>
        <div>
            <b-form>
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <card-title-component :title="$t('account.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col button-div">
                                    <b-button class="delete-account-button o-button" v-on:click="deleteAccountDialog">
                                        {{$t('account.deleteAccountButton')}}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-form>
        </div>
    </div>
</template>

<script>
    import TitleComponent from './shared/TitleComponent'
    import CardTitleComponent from './ui/card/CardTitleComponent'
    import i18n from '../assets/i18n/lang'
    import Vue from 'vue'
    import {mapActions} from 'vuex'
    import {USER_NAMESPACE, USER_ACTION_DELETE_ACCOUNT} from '../store/modules/user-types'

    export default {
        name: 'Account',
        metaInfo () { return {title: i18n.t('account.meta')} },
        components: {
            'title-component': TitleComponent,
            'card-title-component': CardTitleComponent
        },
        computed: {},
        methods: {
            ...mapActions(USER_NAMESPACE, {
                deleteAccount: USER_ACTION_DELETE_ACCOUNT
            }),
            deleteAccountDialog () {
                Vue.swal({
                    title: i18n.t('feedback.deleteAccountConfirmation.title'),
                    text: i18n.t('feedback.deleteAccountConfirmation.text'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'swal-confirm-button',
                    cancelButtonText: i18n.t('feedback.deleteAccountConfirmation.cancelButton'),
                    cancelButtonClass: 'swal-cancel-button',
                    confirmButtonText: i18n.t('feedback.deleteAccountConfirmation.confirmButton'),
                    buttonsStyling: false
                }).then((result) => {
                    if (result.value) {
                        this.deleteAccount()
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/custom/vars';

    .delete-account-button {
        background-color: $omyfu-yellow;
        border-radius: 0;
        border: 0px;
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/AccountComponent.vue